import { Group, RightDiv, LeftDiv } from './styles';
import ChatBox from './chatbox';
import MessageDetail from './messageDetail';
import { useCallback, useState } from 'react';
import { ChatGroupInterface } from '../../interfaces/chatMessageInterface';
import { useHistory } from 'react-router-dom';
import { useMobileDevice } from '../../global/useMobile';
import UserPreferenceSingleton from '../../helpers/userPreferenceSingleton';
import { setLastReadForDiscussion } from '../../services/chatMessageSyncService';
import { rootStore } from '../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import { ROUTES } from '../../routes/urls';
import useScreenSize from './hooks/useScreenSize';

interface Props {
  loadData: () => void;
  loading: boolean;
}

function NavbarMessageData({ loadData, loading }: Props) {
  //States
  const [newGroup, setNewGroup] = useState(false);
  const [attachment, setAttachment] = useState(false);
  const [hideChatBox, setHideChatBox] = useState(false);

  // mobx variables
  const { chatMessageStore } = rootStore;
  const { chatGroups, pinChatGroups, unpinChatGroups } = chatMessageStore || {};

  //Other variable
  const history = useHistory();
  const mobile = useMobileDevice();
  const screenWidth = useScreenSize();
  const isSmallScreen = screenWidth < 1440;

  // Set has read messages false for current selected group
  const updateMessageGroupReducer = useCallback(
    (groupId: string) => {
      if (groupId) {
        const updatedChatGroups = chatGroups?.map((group) =>
          group?.id === groupId ? { ...group, hasUnreadMessages: false } : group
        );
        const updatedPinnedChatGroups = pinChatGroups?.map((group) =>
          group?.id === groupId ? { ...group, hasUnreadMessages: false } : group
        );
        const updatedUnpinnedChatGroups = unpinChatGroups?.map((group) =>
          group?.id === groupId ? { ...group, hasUnreadMessages: false } : group
        );
        chatMessageStore.setChatGroups(updatedChatGroups);
        chatMessageStore.setPinChatGroups(updatedPinnedChatGroups);
        chatMessageStore.setUnpinChatGroups(updatedUnpinnedChatGroups);
      }
    },
    [chatGroups, chatMessageStore, pinChatGroups, unpinChatGroups]
  );

  const onClickGroup = useCallback(
    (group: ChatGroupInterface) => {
      setAttachment(false); // close render existing file
      updateMessageGroupReducer(group?.id);
      setLastReadForDiscussion(group?.id);
      if (mobile) history.push(`${ROUTES.NAVBARMESSAGE_DETAILS_MOBILE}?chatGroup=${group?.id}`);
      else history.push(`${ROUTES.NAVBARMESSAGE}?chatGroup=${group?.id}`);
      UserPreferenceSingleton.getInstance().setLastMessageGroup(group?.id);
      chatMessageStore.setCurrentChatGroup(group);
      setNewGroup(false);
    },
    [chatMessageStore, history, mobile, updateMessageGroupReducer]
  );

  const handleAttachment = useCallback(
    (value: boolean) => {
      // Hide chat box when attachment is true and screen is smaller than 1440px
      if (isSmallScreen) {
        setHideChatBox(value);
      }
      setAttachment(value);
    },
    [isSmallScreen]
  );

  const onClickNewGroup = useCallback(() => {
    setAttachment(false); // close render existing file
    chatMessageStore.setCurrentChatGroup(null);
    setNewGroup(true);
    if (mobile) history.push(`${ROUTES.NAVBARMESSAGE_DETAILS_MOBILE}?newGroup=true`);
  }, [chatMessageStore, history, mobile]);

  const onCloseNewGroup = useCallback(() => {
    setNewGroup(false);
  }, []);

  return (
    <>
      <Group className='messages-group'>
        {!hideChatBox && (
          <LeftDiv>
            <ChatBox
              newGroup={newGroup}
              onClickNewChat={() => onClickNewGroup()}
              onClickChatGroup={onClickGroup}
              loading={loading}
            />
          </LeftDiv>
        )}
        {!mobile && (
          <RightDiv>
            <MessageDetail
              newGroup={newGroup}
              loadData={loadData}
              onCloseNewGroup={onCloseNewGroup}
              loading={loading}
              onClickNewChat={onClickNewGroup}
              attachment={attachment}
              setAttachment={handleAttachment}
            />
          </RightDiv>
        )}
      </Group>
    </>
  );
}

export default observer(NavbarMessageData);
